const DEFAULT_VALUE = 300;

const sleep = (delay = DEFAULT_VALUE) =>
  new Promise(resolve => {
    setTimeout(resolve, delay);
  });

export default sleep;
